import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { Icon, Menu } from 'antd'
import Auxiliary from 'util/Auxiliary'

import { Creators as authActions } from '../../appRedux/ducks/auth/auth'
import { history } from '../../appRedux/store'
import { validRule, RULES } from '../../constants/Entitlements'
import { getMessage } from '../../util/IntlMessages'
import './customStyle.css'
import './SidebarContent.css'

const { SubMenu } = Menu

class SidebarContent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openKeys: [],
      filteredMenus: null,
      menus: [
        { id: 1, name: getMessage('sidebar.home') },
        { id: 2, name: getMessage('dashboard') },
        { id: 3, name: getMessage('report') },
        { id: 4, name: getMessage('sidebar.customer.title') },
        { id: 5, name: getMessage('sidebar.customer.locations.title') },
        { id: 6, name: getMessage('sidebar.customer.wallet.title') },
        { id: 7, name: getMessage('sidebar.actions.title') },
        { id: 8, name: getMessage('sidebar.actions.calendar') },
        { id: 9, name: getMessage('sidebar.actions.timeline') },
        { id: 10, name: getMessage('sidebar.actions.journeys') },
        { id: 11, name: getMessage('sidebar.administrative.title') },
        { id: 12, name: getMessage('menuNameActionTypes') },
        { id: 13, name: getMessage('menuMemberTypes') },
        { id: 14, name: getMessage('menuLocationTypes') },
        { id: 15, name: getMessage('menuMember') },
        { id: 16, name: getMessage('menuNameCustomerTypes') },
        { id: 17, name: getMessage('menuDistrict') },
        { id: 18, name: getMessage('menuReferencePeriod') },
        { id: 19, name: getMessage('menuRegion') },
        { id: 20, name: getMessage('menuConfiguration') },
        { id: 21, name: getMessage('team') },
        { id: 22, name: getMessage('logout') },
        { id: 23, name: getMessage('sidebar.farmers.dashboard') },
        { id: 24, name: getMessage('categoriesAndActions') },
        { id: 25, name: getMessage('dataload') },
        { id: 26, name: getMessage('customer.tab.actionPlan') },
        { id: 27, name: getMessage('menuNameActionTypesJson') },
        { id: 28, name: getMessage('sidebar.customer.wallet.title') }
      ]
    }
  }

  rootSubmenuKeys = ['sub1', 'sub2', 'sub3']

  logout = () => {
    this.props.reset()
    history.replace('/login')
  }

  renderMenuItem(key, to, icon, message, onClick, id) {
    return (
      <Menu.Item key={key}>
        <Link to={to} onClick={onClick ? onClick : () => ({})}>
          <span className="menu-item-span" id={id}>
            {icon && <Icon className="menu-item-icon" type={icon} />}
            <span className="menu-item-icon-text">{getMessage(message)}</span>
          </span>
        </Link>
      </Menu.Item>
    )
  }

  getSubMenuTitle(icon, message, id) {
    return (
      <span className="sub-menu-title">
        <Icon className="menu-item-icon" type={icon} />
        <span className="menuItemLabel" id={id}>
          {getMessage(message)}
        </span>
      </span>
    )
  }

  filterMenu(value) {
    if (value === null || value === '') {
      this.setState({ filteredMenus: null })
    } else {
      const { menus } = this.state
      const filteredMenus = menus.filter((m) => m.name.toLowerCase().includes(value.toLowerCase()))
      this.setState({ filteredMenus })
    }
  }

  disableByFilter(id) {
    const { filteredMenus } = this.state
    if (filteredMenus === null) {
      return true
    }

    const menu = filteredMenus.filter((menu) => menu.id === id)
    return menu.length > 0
  }

  onOpenChange = (openKeys) => {
    const latestOpenKey = openKeys.find((key) => !this.state.openKeys.includes(key))
    if (!this.rootSubmenuKeys.includes(latestOpenKey)) {
      this.setState({ openKeys })
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : []
      })
    }
  }

  render() {
    const { filteredMenus } = this.state
    let accessDashboard = validRule(RULES.DASHBOARD)
    let accessReports = validRule(RULES.REPORT)
    let accessStakeholder = validRule(RULES.CUSTOMER)
    let accessCustomerLinksListWallet = validRule(RULES.CUSTOMER_LINKS)
    let accessJouneys = validRule(RULES.ACTION_TEMPLATE)
    let accessActions = validRule(RULES.ACTION)
    let accessMemberTypes = validRule(RULES.MEMBER_TYPE)
    let accessLocationTypes = validRule(RULES.LOCATION_TYPE)
    let accessMember = validRule(RULES.MEMBER)
    let accessAdministration = validRule(RULES.ADMINISTRATION)
    let accessCustomerTypes = validRule(RULES.CUSTOMER_TYPE)
    let accessDistrict = validRule(RULES.DISTRICT)
    let accessReferencePeriod = validRule(RULES.REFERENCE_PERIOD)
    let accessRegion = validRule(RULES.REGION)
    let accessConfigDocument = validRule(RULES.CONFIG_DOCUMENT)
    let accessMaterials = validRule(RULES.MATERIAL)
    let accessProfile = validRule(RULES.PROFILE)
    let team = validRule(RULES.TEAM)
    let accessFarmersDashboard = validRule(RULES.FARMER_PORTAL)
    let accessCategory = validRule(RULES.CATEGORY)
    let accessDataload = validRule(RULES.DATALOAD)
    let accessActionPlan = validRule(RULES.ACAO)

    return (
      <Auxiliary>
        <div className="gx-sidebar-content">
          <Menu
            mode="inline"
            style={{ borderRadius: '10px' }}
            // OpenKeys={filteredMenus === null ? 'sub1' : ['sub1', 'sub2', 'sub3']}
            openKeys={filteredMenus === null ? this.state.openKeys : ['sub1', 'sub2', 'sub3']}
            onOpenChange={this.onOpenChange}
          >
            {accessDashboard &&
              this.disableByFilter(2) &&
              this.renderMenuItem('sample', '/dashboard', 'dashboard', 'dashboard', '', 'dashboard')}
            {accessReports &&
              this.disableByFilter(3) &&
              this.renderMenuItem('reports', '/reports', 'file-search', 'report', '', 'reports')}
            {accessStakeholder && (
              <SubMenu
                key="sub1"
                className="sub-menu"
                title={this.getSubMenuTitle('user', 'sidebar.customer.title', 'costumerList')}
              >
                {this.disableByFilter(5) &&
                  this.renderMenuItem(
                    'customerkey',
                    '/customer/list',
                    null,
                    'sidebar.customer.locations.title',
                    '',
                    'costumer'
                  )}
                {accessCustomerLinksListWallet &&
                  this.disableByFilter(6) &&
                  this.renderMenuItem(
                    'customerWalletkey',
                    '/customerWallet/list',
                    null,
                    'sidebar.customer.wallet.title',
                    '',
                    'customerWallet'
                  )}
                {accessCustomerLinksListWallet &&
                  this.disableByFilter(28) &&
                  this.renderMenuItem(
                    'alternativeWalletKey',
                    '/alternativeWallet/list',
                    null,
                    'sidebar.alternative.wallet.title',
                    '',
                    'alternativeWallet'
                  )}
              </SubMenu>
            )}
            {/* actions_and_jouneys */}
            {(accessActions || accessJouneys) && (
              <SubMenu
                key="sub2"
                className="sub-menu"
                title={this.getSubMenuTitle('calendar', 'sidebar.actions.title', 'actions')}
              >
                {this.disableByFilter(7) &&
                  accessActions &&
                  this.renderMenuItem('listActions', '/actions/list', null, 'sidebar.actions.title', '', 'listActions')}
                {accessActions &&
                  this.disableByFilter(8) &&
                  this.renderMenuItem('calendarActions', '/actions/calendar', null, 'sidebar.actions.calendar')}
                {accessActions &&
                  this.disableByFilter(9) &&
                  this.renderMenuItem('timelineActions', '/actions/timeline', null, 'sidebar.actions.timeline')}
                {accessJouneys &&
                  this.disableByFilter(10) &&
                  this.renderMenuItem('journeys', '/journeys/list', null, 'sidebar.actions.journeys')}
                {accessActionPlan &&
                  this.disableByFilter(26) &&
                  this.renderMenuItem('actionPlan', '/actionsPlan/list', null, 'customer.tab.actionPlan')}
              </SubMenu>
            )}
            {/* farmers portal dashboard */}
            {accessFarmersDashboard &&
              this.disableByFilter(2) &&
              this.renderMenuItem(
                'farmersDashboardKey',
                '/farmerPortal/dashboard',
                'dot-chart',
                'sidebar.farmers.dashboard'
              )}
            {/* /actions_and_jouneys */}
            {accessAdministration && (
              <SubMenu
                key="sub3"
                className="sub-menu"
                style={{ borderRadius: '0px 0px 10px 10px' }}
                title={this.getSubMenuTitle('setting', 'sidebar.administrative.title')}
              >
                {accessActions &&
                  this.disableByFilter(12) &&
                  this.renderMenuItem('actionTypesKey', '/actionTypes/list', null, 'menuNameActionTypes')}
                {accessMemberTypes &&
                  this.disableByFilter(14) &&
                  this.renderMenuItem('memberTypes', '/memberTypes/list', null, 'menuMemberTypes')}
                {accessLocationTypes &&
                  this.disableByFilter(14) &&
                  this.renderMenuItem('locationTypes', '/locationTypes/list', null, 'menuLocationTypes')}
                {accessMember &&
                  this.disableByFilter(15) &&
                  this.renderMenuItem('member', '/member/list', null, 'menuMember')}
                {accessCustomerTypes &&
                  this.disableByFilter(16) &&
                  this.renderMenuItem('customerTypeskey', '/customerTypes/list', null, 'menuNameCustomerTypes')}
                {accessDistrict &&
                  this.disableByFilter(17) &&
                  this.renderMenuItem('district', '/district/list', null, 'menuDistrict')}
                {accessReferencePeriod &&
                  this.disableByFilter(18) &&
                  this.renderMenuItem('referencePeriod', '/referencePeriod/list', null, 'menuReferencePeriod')}
                {accessCategory &&
                  this.disableByFilter(18) &&
                  this.renderMenuItem('categoriesAndActions', '/category/list', null, 'categoriesAndActions')}
                {accessRegion &&
                  this.disableByFilter(19) &&
                  this.renderMenuItem('region', '/region/list', null, 'menuRegion')}
                {accessConfigDocument &&
                  this.disableByFilter(20) &&
                  this.renderMenuItem('configuration', '/configuration', null, 'menuConfiguration')}
                {accessProfile &&
                  this.disableByFilter(20) &&
                  this.renderMenuItem('profiles', '/profiles', null, 'profile')}
                {team && this.disableByFilter(22) && this.renderMenuItem('team', '/team/list', null, 'team')}
                {/* {accessPermissions && this.renderMenuItem('permissions', '/permissions/list', null, 'permissions')} */}
                {/* {accessHierarchies && this.renderMenuItem('sample4', '/report', null, 'hierarchies')} */}
                {accessMaterials &&
                  this.disableByFilter(15) &&
                  this.renderMenuItem('materials', '/materials/list', null, 'menuMaterials')}
                {accessDataload &&
                  this.disableByFilter(18) &&
                  this.renderMenuItem('dataload', '/dataload', null, 'dataload')}
                {accessActions &&
                  this.disableByFilter(27) &&
                  this.renderMenuItem('actionTypesJsonKey', '/actionTypesjson/list', null, 'menuNameActionTypesJson')}
              </SubMenu>
            )}
            {/* {accessImport && this.renderMenuItem('imports', '/importation', 'upload', 'importation')} */}
            {/* {accessLogout &&
              this.disableByFilter(21) &&
              this.renderMenuItem('logout', '/login', 'faSignOutAlt', 'logout', this.logout)} */}
          </Menu>
        </div>
      </Auxiliary>
    )
  }
}

SidebarContent.propTypes = {}
const mapStateToProps = ({ settings }) => {
  const { navStyle, themeType, locale, pathname } = settings
  return { navStyle, themeType, locale, pathname }
}

export default connect(mapStateToProps, {
  ...authActions
})(SidebarContent)
